module.exports = __webpack_public_path__ + "static/116-tinto-prod-7a3486c7fd873ed993c5c5500b7b72e6.jpg";